import { UntypedFormControl } from "@angular/forms";

export class NumericFieldValidators {
  /**
   * This method is used to check if the numeric input is valid
   * @param control form control
   * @returns error if the input is not valid, otherwise null
   */
  public static isNotCorrectNumericVal(
    control: UntypedFormControl
  ): { [key: string]: any } | null {
    if (control.dirty && control.touched) {
      const input = control.value;
      if (isNaN(input)) {
        return { numeric: true };
      }
    }
    return null;
  }
}
